
import {Constants,ArrayUtil} from '../Constants';
import { Observable } from 'rxjs';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { FdmPlugin, FdmPluginInterface } from './plugins';

export interface DialogData {
    text: string;
    name: string;
    title:string;
    negBtn:any;
}

export class EditorHandler extends FdmPlugin implements FdmPluginInterface {

    debug:boolean = Constants.debug_off;

    // required name identifier
    static meta = {
        label: 'PLUGINS.EDITOR_HANDLER.LABEL',
        name: 'editor-handler',
        tooltip: 'PLUGINS.EDITOR_HANDLER.TOOLTIP',
        translator: 'PLUGINS.EDITOR_HANDLER',
        
        category: FdmPlugin.category.internal,
    };

    open( who:string, text:string = null ) : Observable<any> {
        
        const tmp = new Observable( subscriber => {

            this.openEditorObservable('Editor ' + who, text ).subscribe(result => {

                subscriber.next(result);
                subscriber.complete();

            });

        });

        return tmp;
    }

    openEditorObservable(title: string, text: string): Observable<any> {

        let dialogRef = this.services.dialog.open(EditorDialog, {
            width: '60%',
            height: '860',
            data: {title: title, text: text}
        });

        return dialogRef.afterClosed()
    }

}

@Component({
    selector: 'editor-dialog',
    templateUrl: 'editor-handler.html',
})
export class EditorDialog {

    loading:boolean = false;

    constructor(
        public dialogRef: MatDialogRef<EditorDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {}
        
    onCancelClick(): void {
        this.dialogRef.close(false);
    }

    onSaveClick(): void {
        let el = document.getElementById('texteditor') as HTMLInputElement;
        if ( el ) {
            this.data.text = el.value;
        }
        this.dialogRef.close(this.data);
    }

}
